import { fetchFeed } from '../feedActionsCreator/general';
import { fetch } from '../../api';

export async function fetchRecommendedGroups() {
  const { payload } = await fetch(
    'communities/related',
    { query: { pageSize: 20 } }
  );

  return { data: { groups: payload.groups } };
}

export async function fetchGroups({ pageSize = 20, lang = 'en', es = true, key }) {
  const { payload } = await fetch(
    'communities/search',
    { query: { pageSize, lang, es, key } }
  );
  const { hits, groups: upToDateGroups } = payload;
  const groups = hits.hits.map(g => {
    const source = g._source;
    const upToDateGroup = upToDateGroups.find(x => x.groupId === source.groupId) || {};
    return {
      ...source,
      ...upToDateGroup,
    };
  });

  return { data: { groups } };
}

export function customFetch(arg: any) {
  return () => fetchGroups(arg);
}

export function searchGroups(id: String, searchText: String, query = {}) {
  const feed = { id, dataType: 'groups', hasMore: false, filter: '' };

  if (!searchText) {
    return fetchFeed(feed, true, fetchRecommendedGroups);
  }

  feed.filter = searchText;
  return fetchFeed(feed, false, customFetch({ key: searchText, ...query }));
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/searchActionsCreator/searchGroupsActionsCreator.js